/**
 * Augments the Woolworths Loyalty points filter to display points.
 *
 * @param {Number} amount
 * @param {Number} conversionBase
 */
function loyaltyPointsCalulator(amount, conversionBase = 200, shouldRestrictToMax = false) {
    const maxPoints = 2000;
    const result = Math.round(conversionBase * amount);
    return shouldRestrictToMax && result > maxPoints ? maxPoints : result;
}

module.exports = loyaltyPointsCalulator;



// WEBPACK FOOTER //
// ./src/common/loyalty/loyalty-points-calculator.js